const Data = [
 {
   "id": 1,
   "peopleid": 1,
   "title": "La Baracca",
   "location": "Lismore",
   "desc": "La Baracca is situated on the fringe of Lismore’s CBD. Family owned and operated, this stylish dining experience is fast becoming known as one of the best café/restaurants on the North Coast.\n\nA warm friendly atmosphere coupled with attentive waitstaff creates an environment that will keep you coming back.",
   "website": "https://labaracca.com.au/",
   "imagename": "NSW-1",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 2,
   "peopleid": 2,
   "title": "Preach Cafe",
   "location": "Bondi Beach",
   "desc": "At Preach, we invite you to come and enjoy food, amazing coffee and relax with your friends.\n\nWe want to create healthy, wholesome food (with a few cheat dishes on the side) that puts a smile on your face.",
   "website": "https://www.preachcafe.com/",
   "imagename": "NSW-2",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 3,
   "peopleid": 3,
   "title": "Jim & Harry's",
   "location": "Mount Colah",
   "desc": "Jim and Harry’s is recognised as one of the oldest surviving cafes in the region after being established by a pair of brother-in-laws Jim Efstathiou and Harry Kovelis.",
   "website": "https://www.facebook.com/Jim-Harrys-Lotsa-Food-Cafe-Takeaway-164292366920042/",
   "imagename": "NSW-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 4,
   "peopleid": 4,
   "title": "Becker & Co",
   "location": "Avoca Beach",
   "desc": "Becker & Co is located 1hr north of Sydney at Avoca Beach. \n\nOffering delicious breakfast & lunch meals & great coffee - Becker & Co is a local favourite.",
   "website": "https://www.facebook.com/beckerandco",
   "imagename": "NSW-4",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 5,
   "peopleid": 5,
   "title": "Black Apple",
   "location": "Moonee Beach",
   "desc": "With a warm and inviting atmosphere, friendly staff and upbeat tunes from the 60s and 70s, The Black Apple cafe will quickly become your new favourite place to meet friends for a meal and to grab a coffee. \n\nThe Black Apple menu is made up of honest, healthy food with a tasty twist, featuring base vegetarian dishes you’re invited to build upon them by adding protein like ethically raised bacon, slow roasted beef brisket and crispy tempura chicken.",
   "website": "https://mooneemarket.com.au/portfolio/the-black-apple/",
   "imagename": "NSW-5",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 6,
   "peopleid": 6,
   "title": "Urban espresso lounge",
   "location": "Coffs Harbour",
   "desc": "Offering great breakfast food including, many Asian Salads, Corn & Zucchini Fritters, Acai Bowls, Big Breakfasts, Buddha Bowls, Avo & Fetta Smash, smoothies, juices and great coffee!",
   "website": "https://www.urbanespressolounge.com.au/",
   "imagename": "NSW-6",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 7,
   "peopleid": 7,
   "title": "Heart & Soul",
   "location": "Grafton",
   "desc": "Nourishing ingredient conscious cafe with amazing smoothies, Devine SF, DF and GF sweets, organic Allpress coffee and healthy food options such as salads and wraps. \n\nVisit our little sis espresso bar for on the go eats & coffee in Skinner Street, south side or sit down to the full cafe menu in our licensed flagship cafe on Prince Street.",
   "website": "https://www.cafeheartandsoul.com.au/",
   "imagename": "NSW-7",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 8,
   "peopleid": 8,
   "title": "Dahab Cafe",
   "location": "Dubbo",
   "desc": "Dahab Cafe was established in 2011 after Mali Khattab worked two jobs and nearly went broke trying to save enough cash to get the business off the ground.\n\nMr Khattab put his success down to the relaxed, homely experience the cafe offers customers.",
   "website": "http://restaurantwebexperts.com/DahabCafe/",
   "imagename": "NSW-8",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 9,
   "peopleid": 9,
   "title": "The Bakehouse",
   "location": "North Kellyville",
   "desc": "Situated in Kellyville, our bakery hits every tastebud, by using only the best and finest ingredients. Specialising in artisan breads, homemade cakes, and pies. \n\nWe handcraft everything on site and serve Campos coffee to make sure every morning starts right!",
   "website": "https://www.thebakehousenk.com.au/",
   "imagename": "NSW-9",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 10,
   "peopleid": 10,
   "title": "Fuel Espresso Bar",
   "location": "Brookvale",
   "desc": "From the day it opened in mid-2013, on the corner of Pittwater and Chard roads, co-owners Mark Howlett and Shak Blitz say they have always put their customers first.\n\nConsistent, high quality coffee; & amazing food.",
   "website": "https://www.fuelespressobar.com.au/",
   "imagename": "NSW-10",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 11,
   "peopleid": 11,
   "title": "Dahlias Cafe",
   "location": "Campbelltown",
   "desc": "At Dahlia's Cafe we've created a family friendly environment offering delicious and comforting home style meals and the highest quality coffee.",
   "website": "https://dahliascafe.theorderman.com.au/",
   "imagename": "NSW-11",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 12,
   "peopleid": 12,
   "title": "Humm Coffee Roasters",
   "location": "North Sydney",
   "desc": "Speciality coffee with the finest food. \n",
   "website": "https://www.facebook.com/hummcoffeeroasters/",
   "imagename": "NSW-12",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 13,
   "peopleid": 13,
   "title": "Coffee & Kitchen",
   "location": "Ballina Shire",
   "desc": "Relaxed cafe, take away and catering available. \n\nFresh locally sourced produce and locally roasted coffee beans.",
   "website": "https://www.facebook.com/Coffeekitchenballina/",
   "imagename": "NSW-13",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 14,
   "peopleid": 14,
   "title": "Choux Box",
   "location": "Kingscliff",
   "desc": "Choux Box Restaurant & Bar is nestled in the pretty coastal village of Kingscliff, part of the scenic Tweed Coast, 20 minutes south of the Gold Coast Airport and about 40 minutes North of Byron Bay.\n\nThe Choux Box Restaurant and Bar strives to maintain its good reputation with friendly and passionate staff and by serving fresh and locally sourced food cooked to perfection.",
   "website": "https://www.chouxbox.com.au/",
   "imagename": "NSW-14",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 15,
   "peopleid": 15,
   "title": "Bean2sussex Cafe",
   "location": "Sussex Inlet",
   "desc": "Australian type Cafe..with a twist.\n\nOpen from 6.30am every day for Coffee, Breakfast, Lunch and Dinner.\n",
   "website": "https://www.facebook.com/Bean2sussex-Cafe-104550394774091/",
   "imagename": "NSW-15",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 16,
   "peopleid": 16,
   "title": "Cunning Culinarian",
   "location": "Hunter",
   "desc": "A brand new coffee destination in an old-fashioned atmosphere. \n\nWhilst they may not hand out glossy magazines with their coffees, The Cunning Culinarian is more likely than most to be photographed in one.",
   "website": "https://www.thecunningculinarian.com/",
   "imagename": "NSW-16",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 17,
   "peopleid": 17,
   "title": "Bellayumi",
   "location": "Blacktown",
   "desc": "The Blacktown cafe in St Martins Village was a standout winner in the 'Best Cafe' competition, pulling in a stream of votes from happy customers.\n\nThe owner, Kevin Dein, said the secret to building a satisfied clientele is sticking to the basics of good food and good service.",
   "website": "https://www.facebook.com/Bellayumi-100117501789089/",
   "imagename": "NSW-17",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 18,
   "peopleid": 18,
   "title": "Dan's Coffe Haus",
   "location": "Blaxland",
   "desc": "We serve our own blend of coffee 'Blend Six' as well as select single origins. \n\nOur menu consists of light meals for breakfast and lunch, fresh juice, and flavoursome oversize Freakshakes! come and say hi!",
   "website": "https://www.facebook.com/DCHblaxland/",
   "imagename": "NSW-18",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 19,
   "peopleid": 19,
   "title": "Percy Plunkett",
   "location": "Penrith",
   "desc": "We didn’t get into hospitality, we were born into it. \n\nCoffee | Breakfast | Lunch - Open 7 Days | 7am - 3pm Dine in & Takeaway",
   "website": "https://percyplunkett.com/",
   "imagename": "NSW-19",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 20,
   "peopleid": 20,
   "title": "Once Upon A Time",
   "location": "West Ryde",
   "desc": "Vintage brunch cafe.\n\nSitting at the cafe is like a time travel experience with its rustic shelves adorned with everything from antique telephones to original Arnotts biscuit tins.",
   "website": "https://www.facebook.com/cafeonceuponatime",
   "imagename": "NSW-20",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 21,
   "peopleid": 21,
   "title": "Cucina Espresso",
   "location": "Concord",
   "desc": "Cucina Espresso is a family owned and operated, licensed café restaurant situated in the heart of the inner west. \n\nWe serve locally roasted The Little Marionette Coffee and our Breakfast and lunch menu is designed to satisfy and surprise you using only the freshest ingredients and traditional Italian, authentic ways of cooking.",
   "website": "http://www.cucina-espresso.com.au/",
   "imagename": "GEN-1",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 22,
   "peopleid": 22,
   "title": "Sideways Café",
   "location": "Dulwich Hill",
   "desc": "At Sideways, we make everything on the premises including all the beautifully baked items you see on display. \n\nOur local suppliers provide daily deliveries straight from the fruit market, butchery, delicatessan and bakery to ensure our produce is always at its freshest.",
   "website": "http://www.sidewaysdelicafe.com.au/",
   "imagename": "NSW-22",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 23,
   "peopleid": 23,
   "title": "U & Co Cafe",
   "location": "Kaleen",
   "desc": "Voters were impressed by U & Co’s top notch coffee, scrumptious sweets and menu of simple, perfectly cooked meals, which they serve up seven days a week. \n\nThe family-owned cafe prides itself on sourcing local ingredients, employing friendly locals and being a quiet spot for residents to catch up and grab a coffee or a meal.",
   "website": "http://uandcocafe.com.au/",
   "imagename": "NSW-23",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 24,
   "peopleid": 24,
   "title": "Busy Bean Cafe",
   "location": "East Wagga Wagga",
   "desc": "\n6am Mon-Fri, 7am Sat, all day breakfast, brunch & lunch.\n\nOffering Eatin and takeaways meals, Beraldo coffee, softdrinks, milkshakes, burgers, foccacias, fresh made sandwiches, roast meats, Country Fried Chicken and snacks",
   "website": "https://www.facebook.com/busybeancafewagga",
   "imagename": "NSW-24",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 25,
   "peopleid": 25,
   "title": "5 Loaves Cafe",
   "location": "Harris Park",
   "desc": "Five Loaves Café serves large variety of over-the-counter & al a carte menu items, including Pizza, Finger food and Catering.",
   "website": "http://5loavescafe.com.au/contact-us/",
   "imagename": "GEN-1",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 26,
   "peopleid": 26,
   "title": "Mulberry Tree Cafe",
   "location": "Parramatta",
   "desc": "Here at Mulberry Tree Cafe, we pride ourselves in a simple menu made with fresh ingredients. \n\nWe don’t overcomplicate it; we make all your favourites with a focus on authentic flavours and family service.",
   "website": "https://www.mulberrytreecafe.com.au/",
   "imagename": "NSW-26",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 27,
   "peopleid": 27,
   "title": "The Hideout Cafe and Pizza",
   "location": "Old Toongabbie",
   "desc": "We are a proud family-owned business and have been keeping tastebuds happy since 2016.​ \n\nFrom our hardworking and friendly team to our lovely customers, we pride ourselves on connecting with everybody that walks through our doors.",
   "website": "https://www.thehideoutcafepizza.com/",
   "imagename": "NSW-27",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 28,
   "peopleid": 28,
   "title": "O’Nikki",
   "location": "Miranda",
   "desc": "Inspired by a contemporary interpretation of the Greek archipelago, O'Nikki is a gathering place conceived to galvanize the social life of its community. \n\n​Fresh, regional and locally sourced ingredients drive our simple, modern approach in the kitchen where the focus is on purity, authenticity and the reinterpretation of modern recipes.",
   "website": "https://www.onikki.com.au/",
   "imagename": "NSW-28",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 29,
   "peopleid": 29,
   "title": "Butcher Baker",
   "location": "Byron Shire",
   "desc": "Inspired by the age old artisan trades of butchery and baking, BUTCHER BAKER brings honest food and good times to Bangalow. \n\nLocated in a beautiful heritage building on the main street, this spacious modern café is owned and operated by local husband and wife team, Paul and Amanda Coughran.",
   "website": "https://www.butcherbaker.com.au/",
   "imagename": "NSW-29",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 30,
   "peopleid": 30,
   "title": "Diggies",
   "location": "North Wollongong",
   "desc": "Enjoy early coffee or a breezy brunch as the surf rolls in, footsteps from the sand of North Beach.\n\nAussie beach culture is brought to life via an always evolving menu sourced from high quality, local ingredients. And if you like, pair with a well-curated wine & cocktail list.",
   "website": "https://diggies.com.au/",
   "imagename": "NSW-30",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 31,
   "peopleid": 31,
   "title": "Quotes Cafe",
   "location": "Wollongong",
   "desc": "We love Coffee, Food & Eachother & it shows in everything we do.\nFairtrade Coffee & Lebanese inspired food. Let us be your hosts.",
   "website": "https://www.facebook.com/Quotes.cafe.Wollongong/",
   "imagename": "NSW-31",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 32,
   "peopleid": 32,
   "title": "The Happy Fox",
   "location": "Warilla",
   "desc": "The Happy Fox, a passion project which has proven to be so much more for Brad and Renee, the owners.\n\nIn 2018 they set out to open up a little cafe that allowed us to share our passion for food, good service and great experience - everytime.",
   "website": "https://www.thehappyfox.cafe/",
   "imagename": "NSW-32",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 33,
   "peopleid": 33,
   "title": "Two Doors Up Cafe",
   "location": "Fairy Meadow",
   "desc": "Awesome menu, great food and the best coffee in the Illawarra! We supply fresh food made with the freshest ingredients daily.\n\nWe now provide a fully licensed venue, somewhere to come and chill out on a Friday afternoon after work with a few specialty beers, cocktails and wine…",
   "website": "https://www.facebook.com/twodoorsupcafe/",
   "imagename": "NSW-33",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 34,
   "peopleid": 34,
   "title": "Miss Nellie's Cafe",
   "location": "Kendal",
   "desc": "Located in the township of Kendall, where the beaches of the Camden Haven meet the lush scenic valleys of the hinterland, MISS NELLIE'S CAFE is a modern-yet-classic haven for locals and visitors alike.\n\nThe delightful country-style cafe celebrates the best of the Hastings local produce and offers something for everyone.",
   "website": "https://www.facebook.com/MissNelliesCafe/",
   "imagename": "NSW-34",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 35,
   "peopleid": 35,
   "title": "Seasalt at the Marina",
   "location": "Port Macquarie",
   "desc": "Seasalt Cafe & Restaurant is located overlooking Port Macquarie Marina. We are open for breakfast and lunch 7 days a week from 6.00am. \n\nSit back, relax and take in the view while enjoying one of the best coffees to be found in Port Macquarie. We also offer a great range of fresh cakes to go with it.",
   "website": "http://www.seasaltportmacquarie.com.au/",
   "imagename": "NSW-35",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 36,
   "peopleid": 36,
   "title": "Steam & Cedar",
   "location": "Gladstone",
   "desc": "Artisan coffee, homemade ice cream and delicious freshly baked treats.",
   "website": "https://m.facebook.com/steamandcedar/",
   "imagename": "NSW-36",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 37,
   "peopleid": 37,
   "title": "Bellbird Cafe",
   "location": "Casula",
   "desc": "Our philosophy is guided by the principles of local, sustainable, seasonal, affordable and accessible. \n\nOur flavours are a contemporary blend of modern influences ranging from French and Asian through to South American.",
   "website": "https://www.casulapowerhouse.com/visit/bellbird-dining-and-bar",
   "imagename": "NSW-37",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 38,
   "peopleid": 38,
   "title": "Chef & Crew",
   "location": "Moorebank",
   "desc": "Chef and Crew was established March 2019 by a couple who has a passion for coffee and food.\n\nWe have designed the menu to contain a variety of foods that are tasty, fresh and a little naughty also focusing on dietary restrictions.",
   "website": "https://www.chefandcrew.com.au/",
   "imagename": "NSW-38",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 39,
   "peopleid": 39,
   "title": "Luddenham Village Cafe",
   "location": "Luddenham",
   "desc": "Come & Enjoy Freshly Roasted Coffee and more.\n\nLuddenham Village Café is the hidden gem in the small beautiful country town of Luddenham, located on the Northern Road, it stands smack bang in the centre of Penrith and Narellan.",
   "website": "https://luddenhamcafe.com.au/",
   "imagename": "NSW-39",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 }
]

export default Data


// WEBPACK FOOTER //
// ./src/components/Data.js